import "./index.scss";
import { useState } from "react";
import cn from "classnames";
import { InputMask, type MaskEventDetail } from "@react-input/mask";
import { formatValueByMask, MASK_CHAR } from "../../app/utils/mask";

interface IPhoneInput {
  label?: string;
  placeholder?: string;
  error?: string;
  hint?: string;
  mask: string;
  likePopup?: boolean;
  required?: boolean;
  readonly?: boolean;
  defaultValue?: string;
  onChange: (value: string) => void;
  onBlur?: (value: string) => void;
}

const PhoneInput = ({
  mask,
  onChange,
  label,
  placeholder,
  error,
  hint,
  defaultValue,
  likePopup,
  required,
  readonly,
  onBlur = () => {},
}: IPhoneInput) => {
  const [value, setValue] = useState(
    defaultValue ? formatValueByMask(defaultValue, mask) : mask
  );
  const [detail, setDetail] = useState<MaskEventDetail | null>(null);

  const handleValueChange = (detail: MaskEventDetail) => {
    const value = detail.value;
    setValue(value);
    setDetail(detail);

    if (detail.isValid) {
      onChange(detail.input);
    } else {
      onChange("");
    }
  };

  return (
    <div
      className={cn("phone", {
        readonly,
        phone_popup: !!likePopup,
        phone_required: !!required,
      })}
    >
      <div className="phone__container">
        {label && <label className="phone__label">{label}</label>}
        <div className="phone__content">
          <InputMask
            className="phone__input"
            mask={mask}
            replacement={{ [MASK_CHAR]: /\d/ }}
            placeholder={placeholder}
            showMask={true}
            value={value}
            {...(!readonly
              ? {
                  onMask: (event: any) => handleValueChange(event.detail),
                  onBlur: () =>
                    detail && onBlur(detail.isValid ? detail.input : ""),
                }
              : {})}
          />
          {hint && <span className="phone__hint">{hint}</span>}
          {error && <span className="phone__error">{error}</span>}
        </div>
      </div>
    </div>
  );
};

export default PhoneInput;
